import { render, staticRenderFns } from "./OpenAccountRecord.vue?vue&type=template&id=39c659b5&scoped=true"
import script from "./OpenAccountRecord.vue?vue&type=script&lang=js"
export * from "./OpenAccountRecord.vue?vue&type=script&lang=js"
import style0 from "./OpenAccountRecord.vue?vue&type=style&index=0&id=39c659b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c659b5",
  null
  
)

export default component.exports